<template>
  <v-dialog
      v-model="showEmailModal"
      content-class="email-dialog"
      width="1000"
      style="max-width: 1000px !important; z-index: 1;"
    >
    <v-container class="email-form-container pa-7 elevation-0">
      <v-row class=" elevation-0">
        <v-col
          v-if="!$vuetify.breakpoint.mdAndUp"
          cols="12"
        >
          <img
            src="/img/close.png"
            style="align: right;float: right;"
            @click="showEmailModal = false"
          >
        </v-col>
        <template v-if="!sent">
          <v-col cols="11" class="pt-5 px-5 pb-3">
            <h2 style="font-size: 24px; color:#333;">
              {{ $t('saada_see_lehekylg') }}
            </h2>
          </v-col>
          <v-col cols="1" class="text-right">
            <v-btn
              fab
              x-small
              class="elevation-0 mt-1 mr-0 csr-btn-hover"
              color="white"
              @click="showEmailModal = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-col>
          <v-col class="pt-0 flex-grow-1 flex-shrink-0">
            <ObjectListInfo
              v-if="selectedObject && selectedObject._id"
              :object="selectedObject"
              :booking-now="false"
              :emailing="true"
            />
          </v-col>
          <v-col class="pt-2 pr-4 flex-grow-0 flex-shrink-1">
            <img src="/img/costa_stamp.png" style="height:192px;">
          </v-col>
          <v-col cols="12" class="px-5">
            <v-container class="white rounded-lg px-5 py-7">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="receiverEmail"
                    :label="$t('saaja_email')"
                    outlined
                    class="white"
                    hide-details
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="subject"
                    :label="$t('teema')"
                    outlined
                    class="white"
                    hide-details
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="message"
                    :label="$t('teade')"
                    rows="7"
                    outlined
                    class="white"
                    hide-details
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="senderName"
                    :label="$t('saatja_nimi')"
                    outlined
                    class="white"
                    hide-details
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="senderEmail"
                    :label="$t('saatja_email')"
                    outlined
                    class="white"
                    hide-details
                  />
                </v-col>
                <v-col>
                  <v-btn
                    :disabled="!dataValid"
                    :dark="!!dataValid"
                    class="elevation-1"
                    color="#1E88E5"
                    @click="send($event)"
                  >
                    {{ $t('saada') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </template>
        <v-col v-else cols="12" md="9" class="pa-3">
          <h1>{{ $t('teade_on_saadetud') }}</h1>
          <ul class="contact_form email-form">
            <li>
              <label>{{ $t('saaja_email') }}:</label>
              <span>{{ receiverEmail }}</span>
            </li>

            <li>
              <label>{{ $t('teema') }}:</label>
              <span>{{ subject }}</span>
            </li>

            <li>
              <label>{{ $t('teade') }}:</label>
              <span>{{ message }}</span>
            </li>
            <li>
              <label>{{ $t('saatja_nimi') }}:</label>
              <span>{{ senderName }}</span>
            </li>

            <li>
              <label>{{ $t('saatja_email') }}:</label>
              <span>{{ senderEmail }}</span>
            </li>
          </ul>
          <br>
          <a @click="resetAndBack">{{ $t('saada_veel_üks') }}</a>
          <br><br>
          <v-btn
            style="margin-bottom: 10px; min-width: 155px;"
            type="button"
            @click="showEmailModal = false"
          >
            {{ $t('sulge') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
import api from '../../store/api.js'
import { load } from 'recaptcha-v3'

import ObjectListInfo from '../List/ListObject/ListObject'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

const isValidEmail = email => {
  const re = /\S+@\S+\.\S+/
  return re.test(String(email).toLowerCase())
}

export default {
  name: 'EmailForm',

  components: {
    ObjectListInfo
  },

  data () {
    return {
      sent: false,
      senderEmail: null,
      senderName: null,
      receiverEmail: null,
      subject: null,
      message: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    dataValid () {
      return isValidEmail(this.senderEmail) &&
        isValidEmail(this.receiverEmail) &&
        this.subject
    }
  },

  watch: {
    showEmailModal (value) {
      if (!value) {
        setTimeout(() => {
          this.resetAndBack()
        }, 1000)
      } else {
        this.subject = this.subject || this.selectedObject.objectName
      }
    }
  },

  methods: {
    send (e) {
      if (this.dataValid) {
        load('6LcXu6MZAAAAAPHnlaHBgqjGHzrkJU_HntrFVW0y').then((recaptcha) => {
          recaptcha.execute(this.send2).then((token) => {
            // console.log(token) // Will print the token
            api.shareByEmail({
              token: token,
              senderEmail: this.senderEmail,
              senderName: this.senderName,
              receiverEmail: this.receiverEmail,
              subject: this.subject,
              message: this.message,
              object: this.selectedObject,
              translations: this.translationsByLang,
              lang: this.lang
            })
            this.sent = true
          })
        })
      }
    },

    send2 () {
      console.log('send2???')
    },

    resetAndBack () {
      // this.senderEmail = null
      // this.senderName = null
      this.receiverEmail = null
      // this.subject = null
      // this.message = null
      this.sent = false
    }
  }
}
</script>

<style>
.email-form-container {
  border: 3px solid white;
  background: #ffcb01;
}
.email-form {
  margin-bottom: 0 !important;
  clear: both;
}
.email-dialog {
  max-width: 1000px;
}
</style>
